<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.81159 21.8653L7.02709 18.8578L3.63859 18.1153L3.96934 14.627L1.67334 12L3.96934 9.37301L3.63859 5.88477L7.02709 5.14227L8.81159 2.13477L12.0001 3.48851L15.1886 2.13477L16.9731 5.14227L20.3616 5.88477L20.0308 9.37301L22.3268 12L20.0308 14.627L20.3616 18.1153L16.9731 18.8578L15.1886 21.8653L12.0001 20.5115L8.81159 21.8653ZM9.45009 19.95L12.0001 18.8693L14.5808 19.95L16.0001 17.55L18.7501 16.9193L18.5001 14.1L20.3501 12L18.5001 9.86927L18.7501 7.05002L16.0001 6.45002L14.5501 4.05002L12.0001 5.13076L9.41934 4.05002L8.00009 6.45002L5.25009 7.05002L5.50009 9.86927L3.65009 12L5.50009 14.1L5.25009 16.95L8.00009 17.55L9.45009 19.95ZM10.9501 15.2038L16.2538 9.90002L15.2001 8.81552L10.9501 13.0655L8.80009 10.9463L7.74634 12L10.9501 15.2038Z"
      fill="currentColor"
    />
  </svg>
</template>
